import ApiService from '../_helper/api.service';
import ManagementApiResources from '../../constants/api/resources/management';

const HotelService = {
  getHotels() {
    return ApiService.get(ManagementApiResources.hotels);
  },

  getHotelInfo(id: number) {
    const config = { params: { hotel_id: id } };
    return ApiService.get(ManagementApiResources.hotels + '/details', config);
  },

  addHotel(data: any) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    return ApiService.post(ManagementApiResources.hotels, data, config);
  },

  updateHotel(id: number, data: any) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    data.append('hotel_id', id);
    return ApiService.put(ManagementApiResources.hotels + '/details', data, config);
  },

  getHotelRoomTypes(hotel_id: number) {
    const config = { params: { hotel_id } };
    return ApiService.get(ManagementApiResources.hotelRoomTypes, config);
  },

  getHotelRoomTypesDetails(room_type_id: number) {
    const config = { params: { room_type_id } };
    return ApiService.get(ManagementApiResources.hotelRoomTypesDetails, config);
  },

  getCancellationPolicy(id: number) {
    const config = { params: { hotel_id: id } };
    return ApiService.get(ManagementApiResources.cancellationPolicy, config);
  },

  updateCancellationPolicy(data: any) {
    return ApiService.post(ManagementApiResources.cancellationPolicy, data);
  },

  getTLLincoln(data: any) {
    const config = { params: data };
    return ApiService.get(ManagementApiResources.getAuthTLLincoln, config);
  },

  checkTLLincoln(data: any) {
    return ApiService.post(ManagementApiResources.verifyAuthTLLincoln, data);
  },

  updateTLLincoln(data: any) {
    return ApiService.put(ManagementApiResources.updateAuthTLLincoln, data);
  },

  checkHotelTLLincoln(data: any) {
    return ApiService.post(ManagementApiResources.verifyHotelTLLincoln, data);
  },

  getBeds24(data: any) {
    const config = { params: data };
    return ApiService.get(ManagementApiResources.getAuthBeds24, config);
  },

  checkBeds24(data: any) {
    return ApiService.post(ManagementApiResources.verifyAuthBeds24, data);
  },

  updateBeds24(data: any) {
    return ApiService.put(ManagementApiResources.updateAuthBeds24, data);
  },

  checkHotelBeds24(data: any) {
    return ApiService.post(ManagementApiResources.verifyHotelBeds24, data);
  },

  getTemairazu(data: any) {
    const config = { params: data };
    return ApiService.get(ManagementApiResources.getAuthTemairazu, config);
  },

  getRakutsu(data: any) {
    const config = { params: data };
    return ApiService.get(ManagementApiResources.getAuthRakutsu, config);
  },

  getNeppan(data: any) {
    const config = { params: data };
    return ApiService.get(ManagementApiResources.getAuthNeppan, config);
  },

  getGMOInfo(id: number) {
    const config = { params: { hotel_id: id } };
    return ApiService.get(ManagementApiResources.dataGMO, config);
  },

  updateGMOInfo(data: any) {
    return ApiService.put(ManagementApiResources.dataGMO, data);
  },

  getPriceSettings(data: any) {
    const config = { params: data };
    return ApiService.get(ManagementApiResources.priceSettings, config);
  },

  updatePriceSettings(data: any) {
    return ApiService.put(ManagementApiResources.priceSettings, data);
  },

  getBookingRoomOptions(data: any) {
    return ApiService.get(ManagementApiResources.bookingRoomOptions, { params: data });
  },

  getBookingPlanOptions(data: any) {
    return ApiService.get(ManagementApiResources.bookingPlanOptions, { params: data });
  },
  updateRatePlanPriceSettings(data: any) {
    return ApiService.put(ManagementApiResources.ratePlanPriceSettings, data);
  },
};

export default HotelService;
